import { OAuthStorage } from 'angular-oauth2-oidc';

/**
 * Custom storage used for storing the tokens at client side.
 * Values which need to survive browser redirects are stored
 * in the session storage, all other values are stored in memory.
 */
export class OAuthWebStorage implements OAuthStorage {
  private readonly _data = new Map<string, string>();
  private readonly _sessionStorageKeys = ['PKCE_verifier', 'nonce'];

  getItem(key: string): string | null {
    return this._useSessionStorage(key)
      ? sessionStorage.getItem(key)
      : this._data.get(key) || null;
  }
  removeItem(key: string): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this._useSessionStorage(key)
      ? sessionStorage.removeItem(key)
      : this._data.delete(key);
  }
  setItem(key: string, data: string): void {
    if (this._useSessionStorage(key)) {
      sessionStorage.setItem(key, data);
    } else {
      this._data.set(key, data);
    }
  }

  private _useSessionStorage(key: string): boolean {
    return this._sessionStorageKeys.includes(key);
  }
}
